import { createFileRoute } from '@tanstack/react-router';
import { PlansPage } from '@/features/operator/plans/plans-page';

export const Route = createFileRoute('/operator/plans')({
    staticData: {
        crumbs: [{ label: 'shell.operatorConsole', to: '/operator' }, { label: 'operator.nav.plans' }],
    },
    component: PlansPage,
});
